<template>
	<a
		href="#"
		:class="['action', { 'gold': favored, 'loading': calling }]"
		:title="favored ? 'Von Merkliste entfernen' : 'Zu Merkliste hinzufügen'"
		v-b-tooltip
		@click.prevent="onClick"
	>
		<Icon icon="star"/>
	</a>
</template>

<script>
import Loading from "@/vue/common/Loading";
import CustomerFavorite from "@/api/customer/job-profile/applicant/Favorite";
import ApplicationFavorite from "@/api/application/job-profile/Favorite";
import Icon from "@/vue/icon/Icon";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

const TYPE_CUSTOMER = 'customer';

export default {

	components: {
		Loading,
		Icon,
	},

	props: {
		type: {
			type: String,
			required: true,
		},
		jobProfileId: {
			type: String,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: false,
		},
		initialFavored: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data ()
	{
		return {
			favored: this.initialFavored,
			calling: false,
		};
	},

	methods: {
		onClick ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.FAVORITE)
					.setAction(
						this.favored ? 'Entfernt' : 'Hinzugefügt'
					)
			);

			if (this.calling)
			{
				return;
			}

			if (this.favored)
			{
				this.remove();
				return;
			}

			this.add();
		},
		async add ()
		{
			if (this.calling)
			{
				return;
			}

			this.calling = true;

			try
			{
				if (this.type === TYPE_CUSTOMER)
				{
					await new CustomerFavorite()
						.setJobProfileId(this.jobProfileId)
						.setPseudonymId(this.applicant.id)
						.setJobId(this.jobId)
						.add()
						.call();
				}
				else
				{
					await new ApplicationFavorite()
						.setJobProfileId(this.jobProfileId)
						.setJobId(this.jobId)
						.add()
						.call();
				}

				this.favored = true;

				this.$emit('change', true);
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.calling = false;
		},
		async remove ()
		{
			if (this.calling)
			{
				return;
			}

			this.calling = true;

			try
			{
				if (this.type === 'customer')
				{
					await new CustomerFavorite()
						.setJobProfileId(this.jobProfileId)
						.setPseudonymId(this.applicant.id)
						.remove()
						.call();
				}
				else
				{
					await new ApplicationFavorite()
						.setJobProfileId(this.jobProfileId)
						.remove()
						.call();
				}

				this.favored = false;

				this.$emit('change', false);
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.calling = false;
		},
	},

	watch: {
		initialFavored (value)
		{
			this.favored = value;
		}
	}
}
</script>
